import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { QuestionTypes } from '../../../../constants/QuestionTypes';
import { getAnswersWithSkip, removeAnswer } from '../../../../services/formService';
import { checkImgSize, stripPTag } from '../../../common/commonFuncs';
import Editor from '../../../common/Quill';
import SkipLogic from './Skip_Logic';
class TypeInstitution extends Component {
    // Options = [];

    constructor(props) {
        super(props);
        const { Question_ID, Widget_ID } = this.props;
        this.state = {
            Allow_Multiple_Selection: false,
            Question_ID,
            Question_Type_ID: QuestionTypes.Dropdown,
            Question_Answers: [],
            Widget_ID,
            show: false,
        };
    }

    async componentDidMount() {
        let { data: Question_Answers } = await getAnswersWithSkip(this.state.Question_ID);
        this.setState({ Question_Answers, Allow_Multiple_Selection: this.props.allowMultipleSelection });
    }

    parseToSave = () => {
        let result = [...this.state.Question_Answers];
        result.map((ans) => {
            ans.Answer_Text = stripPTag(ans.Answer_Text);
        });
        return result;
    };

    handleSave = async () => {
        const Question_Answers = this.parseToSave();

        const Question_ID = await this.props.onSave(Question_Answers);
        this.setState({ Question_ID });
    };

    handleRemove = () => {
        this.props.onRemove();
    };

    handldAnswerChange = (text, index) => {
        const Question_Answers = [...this.state.Question_Answers];
        if (!checkImgSize(text)) {
            toast.error('Image file size cannot exceed 1MB.', {
                position: toast.POSITION.TOP_CENTER,
            });
        } else {
            Question_Answers[index]['Answer_Text'] = text;
        }
        this.setState({ Question_Answers });
    };

    handleAnswerRemove = async (index) => {
        const answer = this.state.Question_Answers[index];
        const { data } = await removeAnswer(answer.Answer_ID);
        if (data.includes('Done')) {
            const Question_Answers = [...this.state.Question_Answers];
            Question_Answers.splice(index, 1);
            this.setState({ Question_Answers });
            toast.success('Answer removed');
        } else {
            toast.error(data);
        }
    };

    handleAnswerAdd = () => {
        const Question_Answers = [...this.state.Question_Answers, { Answer_ID: 0, Answer_Text: '', SkipLogic: [] }];
        this.setState({ Question_Answers });
    };

    handleComplexQuestionType = async (Allow_Multiple_Selection) => {
        const { onMultipleSelection } = this.props;
        onMultipleSelection(Allow_Multiple_Selection);
        this.setState({ Allow_Multiple_Selection });
    };

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleSelection = (idx, selected) => {
        let Question_Answers = [...this.state.Question_Answers];
        Question_Answers[idx].SkipLogic = selected;
        this.setState({ Question_Answers });
    };

    render() {
        const { Question_ID } = this.state;
        let { Question_Answers } = this.state;

        return (
            <React.Fragment>
                <div>
                    <div>
                        <div className='form-check form-check-inline'>
                            <input
                                type='radio'
                                className='form-check-input'
                                id={Question_ID + 'single_selection'}
                                name={Question_ID + 'dropdownType'}
                                value='single'
                                checked={!this.state.Allow_Multiple_Selection}
                                onChange={(e) => this.handleComplexQuestionType(false)}
                            />
                            <label htmlFor='single_selection' className='form-check-label'>
                                Single selection
                            </label>
                        </div>

                        <div className='form-check form-check-inline'>
                            <input
                                type='radio'
                                className='form-check-input'
                                id={Question_ID + 'multiple_selection'}
                                name={Question_ID + 'dropdownType'}
                                value='multiple'
                                checked={this.state.Allow_Multiple_Selection}
                                onChange={(e) => this.handleComplexQuestionType(true)}
                            />
                            <label htmlFor='multiple_selection' className='form-check-label'>
                                Allow multiple selection
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    <div className='float-left'>
                        <button className='btn btn-outline-dark' onClick={this.handleShow}>
                            Skip Logic
                        </button>

                        <Modal show={this.state.show} onHide={this.handleClose} id='skip_logic_modal'>
                            <Modal.Header closeButton>
                                <Modal.Title>Skip Logic Editor</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <SkipLogic Widget_ID={this.props.Widget_ID} Answers={Question_Answers} onClose={this.handleClose} />
                            </Modal.Body>

                            <Modal.Footer>
                                <button className='btn btn-secondary btn-sm' onClick={this.handleClose}>
                                    Close
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </div>

                    <div className='float-right'>
                        <button className='btn btn-outline-primary m-2' onClick={this.handleSave}>
                            Save
                        </button>
                        <button className='btn btn-outline-danger' onClick={this.handleRemove}>
                            Delete
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default TypeInstitution;
